import React from 'react';
import ReactDOM from 'react-dom';
import Rodal from 'rodal';
import './rodal.scss';

const CustomRodal = ({
  header,
  visible,
  onClose,
  children,
  style = null,
  headerStyle = null,
  className = null,
  showClose = true,
}) => {
  // The Rodal modal element to be rendered
  const modalContent = (
    <Rodal
      visible={visible}
      onClose={onClose}
      animation={'slideUp'}
      showCloseButton={showClose}
      className={className}
      customStyles={{ zIndex: 9999, ...style, height: 'fit-content' }}
    >
      {header && (
        <div className="header" style={headerStyle}>
          {header}
        </div>
      )}
      <div className="body">{children}</div>
    </Rodal>
  );

  // Render the modal at the top of the DOM using a Portal
  return ReactDOM.createPortal(modalContent, document.body);
};

export { CustomRodal };
